import { Menu } from '@reach/menu-button';
import { createListTrackingOnClick, trackCustomEvent } from 'app/utils/statistics/clientStatistics';
import { useRouter } from 'next/router';
import React from 'react';
import { trackNavigateToCategory, mainMenuItemClickEvent } from 'app/utils/statistics/customEvents';
import {
    StyledMenuButton,
    StyledMenuItem,
    StyledMenuList,
    StyledSection,
    StyledButtonContainer,
    StyledButtonMenuItem,
} from './ExperimentDropdown.styles';
import {
    headerAllCategoriesAlphabeticalData,
    headerAllCategoriesEditorialData,
    HeaderData,
    headerInstrumentalData,
    headerTopCategoriesData,
} from './HeaderData';

export enum ExperimentDropdownVariant {
    ALL_EDITORIAL = 'all-categories-editorial',
    ALL_ABC = 'all-categories-alphabetic',
}

type Props = {
    variant?: ExperimentDropdownVariant;
};

export const ExperimentDropdown = ({ variant }: Props): JSX.Element => {
    const router = useRouter();

    const headerCategoryData = (dropdownVariant: ExperimentDropdownVariant) => {
        switch (dropdownVariant) {
            case ExperimentDropdownVariant.ALL_EDITORIAL:
                return headerAllCategoriesEditorialData;
            case ExperimentDropdownVariant.ALL_ABC:
                return headerAllCategoriesAlphabeticalData;
            default:
                return headerTopCategoriesData;
        }
    };

    const trackCategory = (index: number, menuItem: HeaderData, listId: string) => {
        const handleClick = createListTrackingOnClick({
            listType: 'kategori-meny',
            listId,
        });

        handleClick(undefined, index, menuItem.heading);
    };

    const handleOnSelect = (index: number, menuItem: HeaderData, listId: string): void => {
        trackCategory(index, menuItem, listId);

        router.push(menuItem.slug);
    };

    const handleButtonClick = () => {
        trackCustomEvent(trackNavigateToCategory());
        router.push('/program');
    };

    const trackCategoryMenuNavigation = () => {
        trackCustomEvent(mainMenuItemClickEvent('Kategorier', 3));
    };

    const isAllItems = [ExperimentDropdownVariant.ALL_ABC, ExperimentDropdownVariant.ALL_EDITORIAL].includes(
        variant
    );

    return (
        <Menu>
            <StyledMenuButton onClick={trackCategoryMenuNavigation}>Kategorier</StyledMenuButton>
            <StyledMenuList portal={false} $isAllItems={isAllItems}>
                <StyledSection $isAllItems={isAllItems}>
                    {headerCategoryData(variant).map((menuItem, i) => (
                        <StyledMenuItem
                            key={menuItem.slug}
                            onSelect={() => handleOnSelect(i, menuItem, 'kategorier')}
                            $isAllItems={isAllItems}
                        >
                            {menuItem.heading}
                        </StyledMenuItem>
                    ))}
                </StyledSection>

                <StyledSection isInstrumental $isAllItems={isAllItems}>
                    {headerInstrumentalData.map((menuItem, i) => (
                        <StyledMenuItem
                            key={menuItem.slug}
                            onSelect={() => handleOnSelect(i, menuItem, 'instrumentell')}
                            $isAllItems={isAllItems}
                        >
                            {menuItem.heading}
                        </StyledMenuItem>
                    ))}
                </StyledSection>

                {!isAllItems && (
                    <StyledButtonContainer>
                        <StyledButtonMenuItem onSelect={handleButtonClick}>
                            Fler kategorier
                        </StyledButtonMenuItem>
                    </StyledButtonContainer>
                )}
            </StyledMenuList>
        </Menu>
    );
};

export default ExperimentDropdown;
